module.exports = __webpack_public_path__ + "static/media/sad-mascot.c4eec8cb.svg";